export class MailConfig {


  constructor(json:any) {

  }
}
